export const LineType = Object.freeze({
  SHIPPING: 'SHIPPING',
  ACCESSORIES: 'ACCESSORIES',
  BIKES: 'BIKES',
  MISCELLANEOUS: 'MISCELLANEOUS',
});
